import { render } from "./NewCase.vue?vue&type=template&id=179db824"
import script from "./NewCase.vue?vue&type=script&lang=js"
export * from "./NewCase.vue?vue&type=script&lang=js"

import "./NewCase.vue?vue&type=style&index=0&id=179db824&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/NewCase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "179db824"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('179db824', __exports__)) {
    console.log('reload')
    api.reload('179db824', __exports__)
  }
  
  module.hot.accept("./NewCase.vue?vue&type=template&id=179db824", () => {
    console.log('re-render')
    api.rerender('179db824', render)
  })

}


export default __exports__